// extracted by mini-css-extract-plugin
module.exports = {"resume":"Resume_resume__1Yx_J","education":"Resume_education__3zHG9","education__edu":"Resume_education__edu__stnkw","education__divider":"Resume_education__divider__YilBS"};